import UserRoleEnum from "../Enums/UserRoleEnum";

export const canSeeUsers = (user) => {
  if (!user || !user.roles) return false;
  return user.roles.includes(UserRoleEnum.ADMIN) ||
         user.roles.includes(UserRoleEnum.SYSTEM_ADMIN);
};

export const canAddTrips = (user) => {
  if (!user || !user.roles) return false;
  return user.roles.includes(UserRoleEnum.COORDINATOR) ||
         user.roles.includes(UserRoleEnum.ADMIN) ||
         user.roles.includes(UserRoleEnum.SYSTEM_ADMIN);
};

export const canAccessSubsidies = (user) => {
  if (!user || !user.roles) return false;
  return user.roles.includes(UserRoleEnum.SOLIDARITY_FUND) || user.roles.includes(UserRoleEnum.SYSTEM_ADMIN);
};

export const canAccessFinances = (user) => {
  if (!user?.roles) return false;
  return user.roles.includes(UserRoleEnum.FINANCE) || user.roles.includes(UserRoleEnum.SYSTEM_ADMIN);
};

export const canAccessViews = (user) => {
  return true;
};